module.exports = __webpack_public_path__ + "img/ZRX-USD.7160d3bb.png";